import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFirebaseCRUD } from "../../hooks/useFirebaseCRUD";
import DropdownField from "../Form/DropdownField";
import TextField from "../Form/TextField";
import Button from "../Button";
import ContextMenu from "../ContextMenu";
import Columns from "../Columns";
import Spinner from "../Spinner";

export default function CreateUserRoleBinding({ user }) {
  const navigate = useNavigate();
  const { 
    getCollection,
    createDocument,
    getDocument,
    addToArray,
    loading
  } = useFirebaseCRUD();


  const [userRoles, setUserRoles] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState("");

  useEffect(() => {
    async function fetchRoles() {
      try {
        if (!user?.organization?.id) return;

        const rolesArr = await getCollection(
          `organizations/${user.organization.id}/user-roles`
        );


        const filtered = rolesArr.filter(
          (role) =>
            !user.roleBindings.find(
              (binding) => String(binding.role.id) === String(role.id)
            )
        );


        setUserRoles(filtered);
      } catch (err) {
        console.error("Error fetching roles:", err);
      }
    }

    fetchRoles();
  }, [user]);

  if (!user || loading) {
    return <Spinner />;
  }

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!selectedRoleId) {
        alert("Please select a role");
        return;
      }

      await createDocument(
        `organizations/${user.organization.id}/user-role-bindings/binding_${user.id}_${selectedRoleId}`,
        {
          userId: user.id,
          roleId: selectedRoleId,
          createdAt: new Date(),
        }
      );

      const roleData = await getDocument(
        `organizations/${user.organization.id}/user-roles/${selectedRoleId}`
      );

      if (roleData) {
        await addToArray(`users/${user.id}`, 'roleBindings', {
          id: Date.now(),
          role: {
            id: roleData.id,
            name: roleData.name,
          },
          // secretKey: null,
        });
      }

      navigate(`/users/${user.id}`);
    } catch (err) {
      console.error("Error assigning role:", err);
      alert("Failed to assign role. Check console for details.");
    }
  }

  return (
    <div className="box">
      <form onSubmit={handleSubmit}>
        <Columns>
          <TextField
            label="Organization"
            value={user.organization.name}
            readOnly={true}
            required={true}
          />
          <TextField
            label="User"
            value={user.email}
            readOnly={true}
            required={true}
          />
        </Columns>

        <DropdownField
          name="roleId"
          label="User role"
          required={true}
          value={selectedRoleId}
          onChange={(e) => setSelectedRoleId(e.target.value)}
        >
          <option value="">Select a role</option>
          {userRoles.length > 0 &&
            userRoles.map((role) => (
              <option key={role.id} value={role.id}>
                {role.name}
              </option>
            ))}
          {userRoles.length === 0 && <option>No roles available</option>}
        </DropdownField>

        <div className='flex justify-end'>
          <Button type="submit">Assign</Button>
        </div>
      </form>
    </div>
  );
}